import clsx from "clsx";
import shape from "../../assets/img/shapes/doll-shape-01.webp";


const DollShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-doll-shape-01", props.className)}>
            <img src={shape} alt="rmdr-doll-shape-01" loading="lazy" width={65} height={52} />
        </div>
    )

}

export default DollShape01;
